<template>
  <div class="h5previews">
    <van-nav-bar
        left-arrow
        @click-right="onUse($route.params.id)"
    >
      <span slot="right" style="color: #1989fa" v-if="type !== 'jm'">使用此模板</span>
      <van-button slot="left" icon="arrow-left" size="small" @click="onClickLeft" type="info"/>
    </van-nav-bar>
    <div class="previews" ref="previews" id="h5-arrow">
      <div v-if="loading" class="loading" style="width: 100%;height: 100%">
        <van-circle v-model="currentRate" :rate="0" :speed="100" :text="text"/>
      </div>
      <div v-else :style="{margin:'0 auto',width: width*zoom + 'px',height: height*zoom + 'px',position: 'relative'}">
        <div :style="{
        width: width + 'px',
        height: height + 'px',
        'transform':`scale(${zoom})`,
        'transform-origin': `0 0`
      }">
          <div class="music" v-if="previewPages.setting.bjSwitch" :style="{'transform':`scale(${1 / zoom})`,}">
            <van-icon name="music-o"></van-icon>
            <audio controls="controls" :autoplay="previewPages.setting.autoPlay" v-show="false"
                   :loop="previewPages.setting.loopPlay">
              <source :src="previewPages.setting.musicUrl" type="audio/ogg">
            </audio>
          </div>
          <div class="preview" ref="preview" id="preview" v-if="previewPages.pageList.length !== 0">
            <Swiper class="swiper-no-swiping" :options="swiperOption" ref="swiperOption">
              <SwiperSlide class="swiper-wrapper" v-for="(item,index) in previewPages.pageList" :key="index">
                <PageItem :pageBg="item.pageBg" :page="item.node" :pageItemIndex="index"
                          :realIndex="realIndex"></PageItem>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
    <nut-dialog title="应用模板" :visible="show" @ok-btn-click="onsubmit"
                :closeOnClickModal="false"
                @close="inputDialogClose">
      <div>
        <van-field
            v-model="programName"
            label="节目名称"
            placeholder="请输入节目名称"
            required
        />
        <van-field
            v-model="programgroupName"
            label="节目分组"
            placeholder="请选择节目分组"
            @click="setshowPicker" readonly
            required
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="groupingList.map(res => {
               return res.name
             })"
              title="分组列表"
              @cancel="showPicker = false"
              @confirm="onConfirm"
          ></van-picker>
        </van-popup>
      </div>
    </nut-dialog>

  </div>
</template>

<script>
import PageItem from "./PageItem";
import qs from "qs"
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {mapState} from "vuex"
import {Toast} from "vant";

export default {
  name: "Preview",
  components: {PageItem, Swiper, SwiperSlide},
  props: {},
  data() {
    return {
      index: 0,
      page: [],
      realIndex: 0,
      realIndexc: 0,
      swiperOption: {
        direction: 'vertical',
        notNextTick: true,
        observer: true,
        observeParents: true,
        loop: false,
        effect: 'slide',
        autoplayDisableOnInteraction: false,
        autoplay: false,
        on: {
          init: function () {
            swiperAnimateCache(this);
            this.emit('slideChangeTransitionEnd');//在初始化时触发一次slideChangeTransitionEnd事件
          },
          slideChangeTransitionEnd: function () {
            swiperAnimate(this);
          },
        },
        speed: 2000,
      },
      loading: true,
      currentRate: 0,
      timer: null,
      zoom: 1,
      text: "加载中",
      show: false,
      programName: "",
      programgroupName: "",
      pmId: "",
      groupingList: [],
      programNameIndex: 0,
      showPicker: false,
      type: ""
    }
  },
  created() {
    this.createprogram()
  },

  mounted() {
    document.title = "预览"
    this.type = this.$route.query.type
    this.$nextTick(() => {
      setTimeout(() => {
        const width = document.clientWidth
        const height = document.clientHeight - 46

        if (this.width / this.height < width / height) {
          this.zoom = height / this.height
        } else {
          this.zoom = width / this.width
        }
        this.setLoading()
        this.init()
      }, 300)
    })
  },
  methods: {
    setLoading() {
      this.loading = true
      this.timer = setInterval(() => {
        this.currentRate += parseInt(100 / 15)
      }, 100)

      setTimeout(() => {
        this.loading = false
        clearInterval(this.timer)
      }, 1500)
    },
    setshowPicker() {
      this.showPicker = true
    },
    setSwiperOption() {
      this.swiperOption.direction = this.previewPages.setting.direction
      this.swiperOption.effect = this.previewPages.setting.pageAnimation
      this.swiperOption.speed = this.previewPages.setting.speed ? this.previewPages.setting.speed : 2000
      if (this.previewPages.pageList.length === 1) {
        this.swiperOption.autoplay = false
      } else if (this.previewPages.setting.autoPage) {
        this.swiperOption.autoplay = {delay: 0}
        this.swiperOption.autoplay.delay = this.previewPages.setting.PlaySpeed
        this.swiperOption.autoplay.disableOnInteraction = false
      } else {
        this.swiperOption.autoplay = false
      }
    },
    onConfirm(value, index) {
      this.showPicker = false
      this.programgroupName = value
      this.programNameIndex = index
    },
    onsubmit() {
      this.$ajax.post('/etv/mouldApplyToProgramMould.json', qs.stringify({
        pmId: this.pmId,
        pmName: this.programName,
        pcId: this.groupingList[this.programNameIndex].id
      })).then(res => {
        if (res.data.code === 0) {
          let routeData = this.$router.resolve({
            path: `/h5editer/${this.pmId}`
          })
          setTimeout(() => {
            window.open(routeData.href, '_blank')
          }, 300)
        } else {
          Toast(res.data.msg)
        }
      })
    },
    inputDialogClose() {
      this.dialogShow = false
      this.programShow = false
      this.groupName = ''
      this.resolution = ''
    },
    createprogram() {
      this.$ajax.post('/etv/selectH5ProgramCategoryAlls.json').then(res => {
        if (res.data.code === 0) {
          this.groupingList = res.data.data.pcList
          this.groupingList.map(res => {
            res.name = res.name.split("(")[0]
          })
          this.programgroupName = res.data.data.pcList[0].name
        }
      })
    },
    // 获取场景列表
    async getSceneList() {
      await this.$ajax.post("/etv/selectProgramMouldSceneInfo.json", qs.stringify({pmId: this.$route.params.id})).then(res => {
        if (res.data.code === 0) {
          this.$store.state.width = parseInt(res.data.data[0].resolution.split("*")[0])
          this.$store.state.height = parseInt(res.data.data[0].resolution.split("*")[1])
          this.$store.state.scId = res.data.data[0].scId
        }
      })
    },
    // 获取场景
    async getSceneData(parame, scId) {
      await this.$ajax.post("/etv/selectSceneInfo.json", qs.stringify({
        pmId: this.$route.params.id,
        scId: scId
      })).then(res => {
        if (res.data.code === 0) {
          this.$store.state.previewPages = JSON.parse(res.data.data.componentsList[0].txList[0].taAddress)
        }
      })
    },
    async init() {
      await this.getSceneList(this.$route.params)
      await this.getSceneData(this.$route.params, this.scId)
      this.$nextTick(() => {
        const phoneWidth = this.$refs['previews'].clientWidth
        const phoneHeight = this.$refs['previews'].clientHeight

        if (phoneWidth / phoneHeight < this.width / this.height) {
          this.zoom = phoneWidth / this.width
        } else {
          this.zoom = phoneHeight / this.height
        }

        const w = document.getElementById('h5-arrow').clientWidth * this.zoom
        const h = document.getElementById('h5-arrow').clientHeight * this.zoom


        if (phoneWidth / phoneHeight < this.width / this.height) {
          this.x = 0
          this.y = (phoneHeight - h)
        } else {
          this.x = (phoneWidth - w) / 2
          this.y = 0
        }
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onUse(pmId) {
      this.pmId = pmId
      this.show = true
    },
    onprogramShow() {

    }
  },
  computed: {
    ...mapState({
      pageIndex: state => state.pageIndex,
      previewPages: state => state.previewPages,
      width: state => state.width,
      height: state => state.height,
      scId: state => state.scId,
    }),
    previewPagesCon() {
      return JSON.stringify(this.previewPages)
    }
  },
  watch: {
    previewPagesCon() {
      this.setSwiperOption()
      clearInterval(this.timer)
      this.currentRate = 0
      this.setLoading()
    },
    realIndexc(v) {
      this.realIndex = v
    }
  },

}
</script>

<style lang="scss">
.h5previews {
  height: 100%;
  width: 100%;

  .nut-dialog-footer {
    justify-content: flex-end;
    border: none;
    height: 55px;
  }

  .van-button--small {
    min-width: 10px !important;

    .van-icon {
      color: white;
    }
  }


  .nut-dialog-btn {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    width: 60px;
    flex: none;
    margin-left: 10px;
    border-radius: 5px;
  }

  .nut-dialog-ok {
    border: 1px solid #1B89FA;
    color: #fff;
    background: #1B89FA;
    margin-right: 20px;
  }

  .nut-dialog-cancel {
    border: 1px solid #e41f19;
    color: #e41f19;
  }

  .nut-dialog-cancel:active {
    background: #fff;
    border: 1px solid #e41f19;
  }

  .useTemplate {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;

    .van-cell-group {
      padding: 10px 20px;
    }
  }

  .previews {
    height: calc(100% - 50px);
    width: 100%;
    overflow: hidden;
    position: relative;
    background-size: 100% 100%;
    box-sizing: unset;
    transform: scale(1);
    transform-origin: 0 0;


    .loading {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
    }

    .preview {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .music {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      position: absolute;
      top: 10px;
      right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, .3);
      color: white;
      animation: rotate 2s infinite linear;
      z-index: 9999;

      i {
        font-size: 24px;
        font-weight: bold;
      }
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg) scale(1.2);
      }
      100% {
        transform: rotate(360deg) scale(1.2);
      }
    }
  }
}


</style>
